<app-centered-page-wrapper>
  <form (ngSubmit)="logIn()" method="POST" name="form">
    <div *ngIf="invalid" class="alert alert-danger" role="alert">
      Invalid username or password.
    </div>

    <p *ngIf="sessionExpired && !invalid" class="alert alert-warning">Your session has expired. Please log in again.</p>
    <p *ngIf="!sessionExpired">Sign in to your account.</p>

    <div class="form-group">
      <label for="username">Email address</label>
      <input class="form-control" id="username" [(ngModel)]="username" name="username" required>
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <input class="form-control" id="password" [(ngModel)]="password" name="password" required type="password">
    </div>

    <button class="btn btn-primary mr-2 col-md-12" type="submit" [disabled]="loggingIn">
      <app-loading-spinner *ngIf="loggingIn" [text]="'LOGGING IN...'" noMargin="true"></app-loading-spinner>
      <ng-container *ngIf="!loggingIn">LOG IN</ng-container>
    </button>
    <div class="row d-flex justify-content-around mt-4">
      <div style="font-size: small;" *ngIf="isParentLogin">
        <app-add-parent-account-modal [loggingIn]="loggingIn"></app-add-parent-account-modal>
      </div>
      <a style="font-size: small;" routerLink="/forgot-password">
        <u>FORGOT PASSWORD</u>
      </a>
    </div>
  </form>
</app-centered-page-wrapper>